// The three account/brand roles, mirroring the backend `Role` enum.
export const ROLES = ['ADMIN', 'APPROVER', 'EDITOR'] as const

export type AdminRole = (typeof ROLES)[number]

export interface BrandAccessEntry {
  brandId: string
  roles: AdminRole[]
}
